import { render, staticRenderFns } from "./FieldSettings.vue?vue&type=template&id=e9b8a056&scoped=true"
import script from "./FieldSettings.vue?vue&type=script&lang=js"
export * from "./FieldSettings.vue?vue&type=script&lang=js"
import style0 from "./FieldSettings.vue?vue&type=style&index=0&id=e9b8a056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b8a056",
  null
  
)

export default component.exports